import { Component, ViewEncapsulation } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { Endpoint, HelpIndex, MessageType, UpdateStatusType } from '../../../models/enums';
import { ExportStream } from '../../../models/export-stream';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';

@Component({
    standalone: false,
    selector: 'res-create-near-duplicate-metadata-modal',
    templateUrl: './create-near-duplicate-metadata-modal.component.html',
    styleUrls: ['./create-near-duplicate-metadata-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class CreateNearDuplicateMetadataModalComponent extends BaseModalComponent {
    modalTitle = 'Create Near-Duplicate Metadata';
    automationId = 'create-near-duplicate-metadata-modal';
    isBusy = false;
    isBusyMessage = 'Loading...';
    modalHelpIndex = HelpIndex.exports_create_near_dupe_meta_dlg;
    modalClass = 'create-near-duplicate-metadata';

    exportStream: ExportStream;
    nearDuplicatesThreshold = '80';
    nearDuplicatesMinTermCount = '25';
    nearDuplicatesProcessAttachments = false;

    validation = {
        nearDuplicatesThreshold: {
            change: (): void => {
                this.validation.nearDuplicatesThreshold.invalid = !this.nearDuplicatesThreshold;
            },
            blur: (): void => {
                let val = parseInt(this.nearDuplicatesThreshold, 10);
                if (isNaN(val)) {
                    this.validation.nearDuplicatesThreshold.invalid = true;
                    return;
                }
                if (val < 0) {
                    val = 0;
                } else if (val > 99) {
                    val = 99;
                }
                this.nearDuplicatesThreshold = val.toString();
            },
            invalid: false,
            errorMessage: `"Threshold:" can't be blank.`
        },
        nearDuplicatesMinTermCount: {
            change: (): void => {
                this.validation.nearDuplicatesMinTermCount.invalid = !this.nearDuplicatesMinTermCount;
            },
            blur: (): void => {
                let val = parseInt(this.nearDuplicatesMinTermCount, 10);
                if (isNaN(val)) {
                    this.validation.nearDuplicatesMinTermCount.invalid = true;
                    return;
                }
                if (val < 0) {
                    val = 0;
                } else if (val > 1000000000) {
                    val = 1000000000;
                }
                this.nearDuplicatesMinTermCount = val.toString();
            },
            invalid: false,
            errorMessage: `"Minimum Terms:" can't be blank.`
        }
    };

    constructor(
        private modalService: BsModalService,
        private commonService: CommonService,
        private modalRef: BsModalRef,
        private restService: RestService
    ) {
        super(modalService, modalRef);
        if (this.modalData && this.modalData.exportStream instanceof ExportStream) {
            this.exportStream = this.modalData.exportStream;
        }
    }

    nearDuplicatesProcessAttachmentsEnabled = (): boolean => {
        return this.exportStream && (this.exportStream.options.includeSeperateEmailAttachments || this.exportStream.options.includeOLEChildren);
    }

    okEnabled = (): boolean => {
        return !this.isBusy && this.exportStream && Boolean(this.nearDuplicatesThreshold) && Boolean(this.nearDuplicatesMinTermCount);
    }

    ok = (): void => {
        this.isBusy = true;
        const nearDuplicatesThresholdNumber = parseInt(this.nearDuplicatesThreshold, 10);
        const nearDuplicatesMinTermCountNumber = parseInt(this.nearDuplicatesMinTermCount, 10);
        this.restService.post(Endpoint.exportStreamManager_exportStreamNearDuplicate, {
            nearDuplicatesThreshold: nearDuplicatesThresholdNumber / 100,
            nearDuplicatesMinTermCount: nearDuplicatesMinTermCountNumber,
            nearDuplicatesProcessAttachments: this.nearDuplicatesProcessAttachments,
            exportStreamHandle: this.exportStream.handle,
            projectHandle: this.commonService.currentProject.handle,
            taskDescription: `Performing Near Duplicate Analysis of ${this.exportStream.name}`
        }).then(response => {
            this.isBusy = false;
            this.commonService.sendMessage(MessageType.entityChanged, UpdateStatusType.EXPORT_VIEW);
        }, error => {
            this.isBusy = false;
        });
        this.closeModal();
    }

    restrictNumeric = (event): boolean => {
        if (event) {
            return (event.charCode === 8 || event.charCode === 0) ? false : event.charCode >= 48 && event.charCode <= 57;
        }
        return false;
    }
}
